module.exports = __webpack_public_path__ + "db19bbf603ae4cffa3a8d0dbaf87bebb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-28.png
// module id = 2640
// module chunks = 0